import {Injectable} from '@angular/core';
import {AResourceService} from "./a-resource.service";
import {CurrencyModel} from "../../models/resources/currency.model";
import {LanguageService} from "./language.service";
import {UrlParamModel} from "../../models/url-param.model";

@Injectable({
  providedIn: 'root',
})
export class CurrencyService extends AResourceService<CurrencyModel> {
  constructor(private languageService: LanguageService) {
    super('/currencies', false);
  }

  protected override getDefaultListParams(): UrlParamModel[] {
    const code = this.languageService.activeLanguage()?.code;
    if (!code) {
      return [];
    }
    return [{key: 'lang', value: code}];
  }
}
